import http from '../../utils/fetch';
export default {
    baseurl:'/api/swyl/v1/mubiao',
    baseurl2:'/api',
    //--------------------------msgFunnel  网络对阵--------------------
    selectPage(query){
        return http({
            url: 'api/swyl/v1/net/fight/list',
            method: 'post',
            params: query
        });
    },
    deleteNet(query){
        return http({
            url: 'api/swyl/v1/net/fight/delete?ids='+ query,
            method: 'delete',
            data: query
        });
    },


    ///////区域约定订单预测------------------------------
    pageForecastedOrder(query){
        return http({
            // /api/swyl/v1/orderForecastmonthly/orderForecast/selectOrderForecastPage
            url: '/api/swyl/v1/orderForecastmonthly/orderForecast/selectOrderForecastPage',
            method: 'post',
            data: query
        });
    },
    deleteForecastedOrder(query){
        return http({
            url: '/api/swyl/v1/orderForecastmonthly/orderForecast/delete?ids='+ query,
            method: 'post',
            data: query
        });
    },
    selectOnlyName(query){
        return http({
            url: '/api/swyl/v1/orderForecastmonthly/orderForecast/selectOnlyName?customerName='+ query,
            method: 'post',
            //params: query
        });
    },
    selectByUserNameLoud(query){
        return http({
            url: '/api/swyl/v1/orderForecastmonthly/orderForecast/selectByUserNameLoud?customerName='+ query,
            method: 'post',
            //params: query
        });
    },
    selectProductCode(query){
        return http({
            url: '/api/swyl/v1/orderForecastmonthly/orderForecast/selectProductName?productCode='+ query,
            method: 'post',
            //params: query
        });
    },
    saveOrderForecast(query){
        return http({
            url: '/api/swyl/v1/orderForecastmonthly/orderForecast/saveOrderForecast',
            method: 'post',
            data: query
        });
    },
    editOrderForecast(query){
        return http({
            url: '/api/swyl/v1/orderForecastmonthly/orderForecast/edit',
            method: 'post',
            data: query
        });
    },

    ////////-----签约网络月度抢单-客户----------------------------
    selectPageCustom(query){
        return http({
            url: '/api/swyl/v1/monthly/order/selectPage',
            method: 'post',
            params: query
        });
    },
    selectOrdersCustom(query){
        return http({
            url: '/api/swyl/v1/monthly/order/selectPage',
            method: 'post',
            params: query
        });
    },
    // 客户名称
    selectUserName(query){
        return http({
            url: '/api/swyl/v1/monthly/order/getUserAreaAndUsernameByUserName?username='+ query,
            method: 'post',
            //data: query
        });
    },

    // 用户单位查询
    findByNameList(query){
        return http({
            url: '/api/swyl/v1/yonghu/bscCustagent/selectByName?name='+ query,
            method: 'post',
            //data: query
        });
    },

    selectUserId(query){
        return http({
            url: '/api/swyl/v1/monthly/order/getUserAreaAndUsernameByUserId?username='+ query,
            method: 'post',
            //data: query
        });
    },
    //漏斗
    selectLoudProjectList(query){
        return http({
            url: '/api/swyl/v1/monthly/order/getLoudProjectList',
            method: 'post',
            params: query
        });
    },
    selectLoudProject(query){
        return http({
            url: '/api/swyl/v1/monthly/order/getLoudProject',
            method: 'post',
            params: query
        });
    },
    getdaqujingli(query){
        return http({
            url: '/api/swyl/v1/demo/bscUserDayCleanConfig/getdaqujingli',
            method: 'post',
            params: query
        });
    },
    
    userNamesBydaquSale(query){
        return http({
            url: '/api/swyl/v1/demo/bscUserDayCleanConfig/userNamesBydaquSale',
            method: 'post',
            params: query
        });
    },

    selectLoudCucodeList(query){
        return http({
            url: '/api/swyl/v1/monthly/order/getLoudCucodeList',
            method: 'post',
            params: query
        });
    },
    //达成目标
    selectTemplateTargetList(query){
        return http({
            url: '/api/swyl/v1/monthly/order/getTemplateTargetList',
            method: 'post',
            params: query
        });
    },
    // /api/swyl/v1/monthly/order/getRebateSeriesList
    selectRebateSeriesList(query){
        return http({
            url: 'api/swyl/v1/monthly/order/getRebateSeriesList',
            method: 'post',
            params: query
        });
    },

    //目标模板
    selectTargetPlanList(query){
        return http({
            url: '/api/swyl/v1/monthly/order/getTargetPlanList',
            method: 'post',
            params: query
        });
    },
    //新增 - 签约
    saveOrdersCustom(query){
        return http({
            url: '/api/swyl/v1/monthly/order/add',
            method: 'post',
            data: query
        });
    },

    ///  客户---非签约
    selectPageNoSignCustom(query){
        return http({
            url: '/api/swyl/v1/monthly/order/NoSign/selectPage',
            method: 'post',
            params: query
        });
    },
    //新增 - 非签约
    saveNoSignCustom(query){
        return http({
            url: '/api/swyl/v1/monthly/order/NoSign/add',
            method: 'post',
            data: query
        });
    },

    // 修改  --公共
    editOrdersCustom(query){
        return http({
            url: '/api/swyl/v1/monthly/order/common/edit',
            method: 'post',
            data: query
        });
    },

    //删除 -- 公共
    deleteCustom(query){
        return http({
            url: '/api/swyl/v1/monthly/order/common/delete',
            method: 'delete',
            params: query
        });
    },
    //批量审批
    approveBatchId(query){
        return http({
            url: '/api/swyl/v1/monthly/order/approveBatchId',
            method: 'post',
            data: query
        });
    },

    auditBatchId(query){
        return http({
            url: '/api/swyl/v1/monthly/order/auditBatchId',
            method: 'post',
            data: query
        });
    },

    overruleBatchId(query){
        return http({
            url: '/api/swyl/v1/monthly/order/overruleBatchId',
            method: 'post',
            data: query
        });
    },

    listByModelProduct(query1,query2){
        return http({
            url: '/api/swyl/v1/loudnew/loudMainProduct/listByModel?materialCodeNameLike='+ query1+'&lianqun='+query2,
            method: 'post',
            // data: query
        });
    },
    ////////-----新月度抢单----------------------------
    // 获取 经销商
    // selectByUserNameLoud(query){
    //     return http({
    //         url: '/api/swyl/v1/orderForecastmonthly/orderForecast/selectByUserNameLoud',//?customerName=1
    //         method: 'post',
    //         data: query
    //     });
    // },
// 获取 销售人员
    getUserList(query){
        return http({
            url: '/api/swyl/v1/month/bscUserMonthlyOrderGrab/getUserList',
            method: 'post',
            data: query
        });
    },
    //新增
    insertMonthly(query){
        return http({
            url: '/api/swyl/v1/month/bscUserMonthlyOrderGrab/insertMonthly',
            method: 'post',
            data: query
        });
    },
//修改
    updateMonthly(query){
        return http({
            url: '/api/swyl/v1/month/bscUserMonthlyOrderGrab/updateMonthly',
            method: 'post',
            data: query
        });
    },
//获取列表数据
    selectMonthlyList(query){
        return http({
            url: '/api/swyl/v1/month/bscUserMonthlyOrderGrab/selectMonthlyListPage',
            method: 'post',
            params: query
        });
    },
//获取漏斗信息 传参loudmain loudIdList:[1,2,3]
    getLoudList(query){
        return http({
            url: '/api/swyl/v1/month/bscUserMonthlyOrderGrab/getLoudListPage',
            method: 'post',
            params: query
        });
    },
//获取渠道目标
    getTargetChannel(query){
        return http({
            url: '/api/swyl/v1/month/bscUserMonthlyOrderGrab/getTargetChannel',
            method: 'post',
            data: query
        });
    },
//审批通过或驳回
    monthlyPass(query){
        return http({
            url: '/api/swyl/v1/month/bscUserMonthlyOrderGrab/monthlyPass',
            method: 'post',
            data: query
        });
    },
    // 获取签约目标
    getNotLoudTarget(query){
        return http({
            url: '/api/swyl/v1/month/bscUserMonthlyOrderGrab/getNotLoudTarget',
            method: 'post',
            data: query
        });
    },
    // 抢单预览
    monthlyListByHistory(query){
        return http({
            url: '/api/swyl/v1/month/bscUserMonthlyOrderGrab/monthlyListByHistory',
            method: 'post',
            params: query
        });
    },
    deleteMonthly(query){
        return http({
            url: '/api/swyl/v1/month/bscUserMonthlyOrderGrab/deleteMonthly',
            method: 'post',
            params: query
        });
    },
    // 根据对象获取实体
    selectByInstid(query){
        return http({
            url: '/api/swyl/v1/month/bscUserMonthlyOrderGrab/selectByInstid',
            method: 'post',
            params: query
        });
    },
}
